import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { handleGetInvoices } from './invoiceThunk';
import { IInvoice, IParamsGetInvoices } from '~/utils/interface/invoice';
import { DEFAULT_PAGE, ROWS_PER_PAGE } from '~/utils/constants/common';

export interface IInvoiceState {
  filter: IParamsGetInvoices;
  currentPage: number;
  totalPages: number;
  needRefreshData: boolean;
  invoices: Array<IInvoice>;
  selectedIds: Array<string>;
  openAlertDelete: boolean;
  menuSelectedId: string | undefined;
  invoiceId?: string;
}

const initialState: IInvoiceState = {
  currentPage: DEFAULT_PAGE,
  totalPages: 0,
  needRefreshData: false,
  filter: {
    page: 1,
    limit: ROWS_PER_PAGE,
    search: '',
    searchFields: [],
    sort: [],
    status: '',
    expireDateTo: '',
  },
  selectedIds: [],
  invoices: [],
  openAlertDelete: false,
  menuSelectedId: undefined,
  invoiceId: undefined,
};

const invoiceSlice = createSlice({
  name: 'invoice',
  initialState,
  reducers: {
    changeNeedRefreshData(state, action: PayloadAction<boolean>) {
      state.needRefreshData = action.payload;
    },
    setFilter(state, action: PayloadAction<IParamsGetInvoices>) {
      state.filter = { ...state.filter, ...action.payload };
    },
    changeSelectedIds(state, action: PayloadAction<Array<string>>) {
      state.selectedIds = [...action.payload];
    },
    changeInvoiceId(state, action: PayloadAction<string>) {
      state.invoiceId = action.payload;
    },
    changeOpenAlertDelete(state, action: PayloadAction<boolean>) {
      state.openAlertDelete = action.payload;
    },
    changeMenuSelectId(state, action: PayloadAction<string | undefined>) {
      state.menuSelectedId = action.payload;
    },
  },

  extraReducers(builder) {
    builder.addCase(handleGetInvoices.fulfilled, (state, action) => {
      state.invoices = [...action.payload.responses];
      state.currentPage = action.payload.pagination.page;
      state.totalPages = action.payload.pagination.totalPages;
      state.needRefreshData = false;
    });
  },
});

export const invoiceActions = invoiceSlice.actions;

const invoiceReducer = invoiceSlice.reducer;
export default invoiceReducer;
